import { AppContext } from './AppContext';
import { useContext } from 'react';

export const useV2Info = () => {
  const context = useContext(AppContext);

  return context.v2Info;
};
